import React from 'react';
import { cn } from '@/lib/utils';

export type StatusDotType = 'scheduled' | 'edited' | 'dismissed';

interface StatusDotProps {
  type: StatusDotType;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

const statusConfig = {
  scheduled: {
    color: 'bg-blue-500',
    label: 'Scheduled',
    ariaLabel: 'From schedule - not edited',
  },
  edited: {
    color: 'bg-orange-500',
    label: 'Edited',
    ariaLabel: 'From schedule - edited',
  },
  dismissed: {
    color: 'bg-gray-400',
    label: 'Dismissed',
    ariaLabel: 'Dismissed from schedule',
  },
};

const sizeConfig = {
  sm: 'w-2 h-2',
  md: 'w-2.5 h-2.5',
  lg: 'w-3 h-3',
};

export const StatusDot: React.FC<StatusDotProps> = ({
  type,
  className,
  size = 'md',
}) => {
  const config = statusConfig[type];
  const sizeClass = sizeConfig[size];

  return (
    <span
      className={cn(
        'inline-block rounded-full flex-shrink-0',
        config.color,
        sizeClass,
        className
      )}
      aria-label={config.ariaLabel}
      title={config.label}
      role="status"
    />
  );
};

export default StatusDot;
